import React, { useState } from "react";
import { Button, VStack, Heading, Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router";
import { FormInput } from "../FormInput";
import { MailWithCodeIcon } from "../Icons/MailWithCodeIcon";


export const ConfirmSignUp = ({ username, onConfirmSignUp, resendCode, isLoading }) => {
    const [code, setCode] = useState("")
    const navigate = useNavigate();
    return (
        <VStack spacing={5}>
            <Heading>Confirm Sign Up</Heading>
            <Flex
                spacing={5}
                sx={{
                    alignItems: "stretch",
                    justifyContent: "space-between"
                }}
            >
                <MailWithCodeIcon />
                <Text 
                    sx={{
                        margin: "0 0 0 20px"
                    }}
                >
                    We have sent a code in an Email message to {username}. To confirm your account, enter your code.</Text>
            </Flex>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    onConfirmSignUp(code);
                }}
                style={{
                    width: "100%"
                }}
            >
                <VStack spacing={5} align="flex-start">
                    <FormInput
                        label="Code"
                        name="code"
                        type="text"
                        placeholder="Enter Code"
                        inputOnChange={(e) => setCode(e.target.value)}
                        value={code}
                        formProps={{ isRequired: true }}
                        padding="0"
                        inputProps={{disabled: isLoading}}
                    />
                    <Button 
                        variant="link" 
                        colorScheme="blue" 
                        type="button"
                        isLoading={isLoading}
                        loadingText="Sending code"
                        onClick={resendCode}
                    >Resend Code</Button>
                    <Button colorScheme="blue" width="full" type="submit">
                        Confirm account
                    </Button>
                </VStack>
            </form>
            <Text>
                Already confirmed your email? <Button variant="link" disabled={isLoading} colorScheme="blue" onClick={() => { navigate('/') }}>Sign In</Button>
            </Text>
        </VStack>
    )
}
